module.exports = __webpack_public_path__ + "static/media/beincrypto.5819d0ba.jpeg";